
import { OktaAuth } from "@okta/okta-auth-js";
import oktaConfig from "./oktaConfig";

const authClient = new OktaAuth({
    issuer: oktaConfig.issuer,
    clientId: oktaConfig.cliendId,
    redirectUri: oktaConfig.redirectUri,
    scopes: oktaConfig.scopes
})

export default authClient;